import {Component, OnInit} from '@angular/core';
import {NavigationEnd, NavigationStart, Router, Event as RouterEvent} from "@angular/router";

/**
 * Landing component as the initial page of the project which contains a button that allows the user to go to the file upload page where Excel files can be uploaded.
 */
@Component({
    selector: 'PIDB-landing',
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {

    //Loader variable default true before page load
    loader = false;
    constructor(private router: Router) {
        this.router.events.subscribe((e : RouterEvent) => {
            this.navigationInterceptor(e);
        })
    }

    ngOnInit(): void {
    }

    /**
     * Navigate to file upload page whenever get started button is clicked.
     */
    getStarted() {
        this.router.navigate(['/home/file-upload']);
    }

    navigationInterceptor(event: RouterEvent): void {
        if (event instanceof NavigationStart) {
            this.loader = true;
        }
        if (event instanceof NavigationEnd) {
            setTimeout(()=>{
                this.loader = false;
            }, 2000);
        }

    }
}
